import { Div2Floor } from "./Div2Floor";
import { XML_ScaleAndShiftX } from "./XML_ScaleAndShiftX";
import { XML_ScaleAndShiftY } from "./XML_ScaleAndShiftY";
import { XML_Scale } from "./XML_Scale";
import { XML_Cmd1 } from "./XML_Cmd1";
import { XML_CreateTriPath2 } from "./XML_CreateTriPath2";

export function XML_DrawTri2PDF(
  sx,
  sy,
  width,
  height,
  triColor,
  subTriColor,
  drawElement,
  layer,
  leftTri
) {
  var ex = sx + width;
  var ey = sy + height;

  var inset = 2;
  var h = ey - sy - inset * 2;
  var ax = ex - inset - h;
  var ay = sy + inset;
  var cx = ex - inset;
  var cy = ey - inset;
  if (leftTri) {
    ax = ex - inset;
    ay = sy + inset;
    cx = ex - h - inset;
    cy = ey - inset;
  }

  ax = XML_ScaleAndShiftX(ax, drawElement, layer);
  cx = XML_ScaleAndShiftX(cx, drawElement, layer);
  ay = XML_ScaleAndShiftY(ay, drawElement, layer);
  cy = XML_ScaleAndShiftY(cy, drawElement, layer);

  ay = drawElement.ConvertY(ay);
  cy = drawElement.ConvertY(cy);

  if (triColor != null) {
    XML_CreateTriPath2(ax, ay, cx, cy, drawElement);
    XML_Cmd1("fi", triColor, drawElement);
  }

  if (subTriColor != null) {
    var h2 = XML_Scale(h, drawElement, layer);
    var h2 = Div2Floor(h2) - 1;
    ay = ay - h2;
    if (leftTri) ax = ax - h2;
    else ax = ax + h2;
    XML_CreateTriPath2(ax, ay, cx, cy, drawElement);
    XML_Cmd1("fi", subTriColor, drawElement);
  }
}
